import { render, staticRenderFns } from "./tips1.vue?vue&type=template&id=74272a8a"
import script from "./tips1.vue?vue&type=script&lang=js"
export * from "./tips1.vue?vue&type=script&lang=js"
import style0 from "./tips1.vue?vue&type=style&index=0&id=74272a8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports